import { render } from "./RoundedBtn.vue?vue&type=template&id=bda44822&scoped=true"
import script from "./RoundedBtn.vue?vue&type=script&lang=js"
export * from "./RoundedBtn.vue?vue&type=script&lang=js"

import "./RoundedBtn.vue?vue&type=style&index=0&id=bda44822&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda44822"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QImg});
